import React from 'react';
import { Description, Field } from '@headlessui/react';
import useAppContext from 'flow/hooks/useAppContext';
import Toggle from 'flow/components/ui-components/Toggle';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectVideoShowIncomingVideo } from 'flow/selectors/video-selectors';
import { saveShowIncomingVideoStatus } from 'flow/actions/video-actions';

/**
 * "Show incoming video" row for the meeting settings dialog. Turning it off
 * closes the remote camera receiver peers (VID-53), so the SFU stops
 * forwarding those streams. This saves bandwidth and decoding load, and the
 * feeds fall back to avatars. Persisted per browser.
 */
const MeetingShowIncomingVideoToggle = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const showIncomingVideo = useAppSelector(selectVideoShowIncomingVideo);

    // A HeadlessUI Field: the Description below becomes the switch's
    // aria-describedby, so a screen reader reads the explanation with it.
    return (
        <Field as="div" className="mt-1 border-t border-white/10 pt-4">
            <div className="flex items-center justify-between">
                <span>
                    {i18next.t('videoconference.settings.show_incoming_video')}
                </span>
                <Toggle
                    value={showIncomingVideo !== false}
                    onChange={(enabled) =>
                        dispatch(saveShowIncomingVideoStatus(enabled))
                    }
                    activeColor="bg-green"
                    text={i18next.t(
                        'videoconference.settings.show_incoming_video',
                    )}
                />
            </div>
            <Description as="p" className="mt-1 text-sm text-gray-400">
                {i18next.t(
                    'videoconference.settings.show_incoming_video_description',
                )}
            </Description>
        </Field>
    );
};

export default MeetingShowIncomingVideoToggle;
